<template>
	<section style="min-height: calc(100vh - 100px)">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</section>
</template>

<script>
export default {
  name: 'contentView',
  computed: {
    key() {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/contentView.vue